import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import latencyReducer from "./slices/latencySlice";
import authReducer from "./slices/authSlice";
import entropyConsumptionReducer from "./slices/entropyConsumptionSlice";
import requestsReducer from "./slices/requestsSlice";
import cpuReducer from "./slices/cpuSlice";
import memoryReducer from "./slices/memorySlice";
import networkReducer from "./slices/networkSlice";
import { createStatusApi } from "./statusAPI";
import { createOutboundStreamsApi } from "./outboundStreamsAPI";
import { createAuthApi } from "./authAPI";
import { createIPsecApi } from "./IPsecTunnelsAPI";
import { createApiKeysApi } from "./apiKeysAPI";
import { createAuditLogsApi } from "./auditLogsAPI";
import { createBLASTEndpointsApi } from "./BLASTEndpointsAPI";
import { createNodesApi } from "./nodesAPI";
import { createClustersApi } from "./clustersAPI";
import nodesReducer from "./slices/nodesSlice";
export const DEFAULT_STATUS_REDUCER_PATH = "statusAPI_http://localhost";
export const defaultStatusAPI = createStatusApi("");
export const DEFAULT_OUTBOUND_STREAMS_REDUCER_PATH = "outboundStreamsAPI_http://localhost";
export const defaultOutboundStreamsAPI = createOutboundStreamsApi("");
export const DEFAULT_AUTH_API_REDUCER_PATH = "authApi_";
export const defaultAuthApi = createAuthApi("");
export const DEFAULT_IPSEC_API_REDUCER_PATH = "ipsecApi_";
export const defaultIPsecApi = createIPsecApi("");
export const DEFAULT_API_KEYS_API_REDUCER_PATH = "apiKeysApi_";
export const defaultApiKeysApi = createApiKeysApi("");
export const DEFAULT_AUDIT_LOGS_API_REDUCER_PATH = "auditLogsApi_";
export const defaultAuditLogsApi = createAuditLogsApi("");
export const DEFAULT_BLAST_ENDPOINTS_API_REDUCER_PATH = "blastEndpointsApi_";
export const defaultBLASTEndpointsApi = createBLASTEndpointsApi("");
export const DEFAULT_NODES_API_REDUCER_PATH = "nodesAPI_http://localhost";
/*
export const defaultNodesApi = createNodesApi("") as any;
*/ export const DEFAULT_CLUSTERS_API_REDUCER_PATH = "clustersAPI_";
export const defaultClustersApi = createClustersApi("");
const rootReducer = combineReducers({
    [defaultStatusAPI.reducerPath]: defaultStatusAPI.reducer,
    [defaultOutboundStreamsAPI.reducerPath]: defaultOutboundStreamsAPI.reducer,
    [defaultAuthApi.reducerPath]: defaultAuthApi.reducer,
    [defaultIPsecApi.reducerPath]: defaultIPsecApi.reducer,
    [defaultApiKeysApi.reducerPath]: defaultApiKeysApi.reducer,
    [defaultAuditLogsApi.reducerPath]: defaultAuditLogsApi.reducer,
    [defaultBLASTEndpointsApi.reducerPath]: defaultBLASTEndpointsApi.reducer,
    [defaultClustersApi.reducerPath]: defaultClustersApi.reducer,
    // [defaultNodesApi.reducerPath]: defaultNodesApi.reducer,
    latency: latencyReducer,
    entropyConsumption: entropyConsumptionReducer,
    requests: requestsReducer,
    cpu: cpuReducer,
    memory: memoryReducer,
    network: networkReducer,
    auth: authReducer,
    nodes: nodesReducer
});
// The store setup is wrapped in `makeStore` to allow reuse
// when setting up tests that need the same store config
export const makeStore = (statusAPI, outboundStreamsAPI, authApi, ipsecApi, apiKeysApi, auditLogsApi, blastEndpointsApi, nodesApi = createNodesApi(""), clustersApi = defaultClustersApi)=>{
    const rootReducer = combineReducers({
        [statusAPI.reducerPath]: statusAPI.reducer,
        [outboundStreamsAPI.reducerPath]: outboundStreamsAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [ipsecApi.reducerPath]: ipsecApi.reducer,
        [apiKeysApi.reducerPath]: apiKeysApi.reducer,
        [auditLogsApi.reducerPath]: auditLogsApi.reducer,
        [blastEndpointsApi.reducerPath]: blastEndpointsApi.reducer,
        [nodesApi.reducerPath]: nodesApi.reducer,
        [clustersApi.reducerPath]: clustersApi.reducer,
        latency: latencyReducer,
        entropyConsumption: entropyConsumptionReducer,
        requests: requestsReducer,
        cpu: cpuReducer,
        memory: memoryReducer,
        network: networkReducer,
        auth: authReducer,
        nodes: nodesReducer
    });
    const store = configureStore({
        reducer: rootReducer,
        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat(statusAPI.middleware, outboundStreamsAPI.middleware, authApi.middleware, ipsecApi.middleware, apiKeysApi.middleware, auditLogsApi.middleware, blastEndpointsApi.middleware, nodesApi.middleware, clustersApi.middleware)
    });
    // configure listeners using the provided defaults
    // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
    setupListeners(store.dispatch);
    return store;
};
